function formatWeekdayList(labels?: string[] | null): string {
  const normalized = (Array.isArray(labels) ? labels : [])
    .map((label) => String(label || "").trim())
    .filter(Boolean);
  if (normalized.length === 0) return "os dias contratados";
  if (normalized.length === 1) return normalized[0] || "o dia contratado";
  if (normalized.length === 2) return `${normalized[0]} e ${normalized[1]}`;
  return `${normalized.slice(0, -1).join(", ")} e ${normalized[normalized.length - 1]}`;
}

function formatDateOnly(value?: string | null): string | null {
  const raw = String(value || "").trim();
  if (!raw) return null;
  const dateOnly = raw.match(/^(\d{4})-(\d{2})-(\d{2})/)?.[0] || "";
  if (dateOnly) {
    const [, year, month, day] = dateOnly.match(/^(\d{4})-(\d{2})-(\d{2})/) || [];
    if (year && month && day) return `${day}/${month}/${year}`;
  }

  const date = new Date(raw);
  if (!Number.isFinite(date.getTime())) return null;
  return date.toLocaleDateString("pt-BR");
}

export function resolveCustomerCoveragePromptMessage(params: {
  reason: string;
  fallbackMessage: string;
  requiredProviderName?: string | null;
  selectedProviderName?: string | null;
  scheduledWeekdayLabel?: string | null;
  coveredWeekdayLabels?: string[];
  selectedDate?: string | null;
  currentPeriodEnd?: string | null;
}): string {
  if (params.reason === "WEEKDAY_NOT_INCLUDED") {
    const coveredDays = formatWeekdayList(params.coveredWeekdayLabels);
    const selectedDay = params.scheduledWeekdayLabel || "o dia escolhido";
    return `Sua assinatura cobre ${coveredDays}. O horário escolhido é ${selectedDay}, então este agendamento não entra na assinatura.`;
  }

  if (params.reason === "PROVIDER_NOT_INCLUDED") {
    const requiredProvider = params.requiredProviderName || "outro profissional";
    const selectedProvider = params.selectedProviderName || "o profissional escolhido";
    return `Sua assinatura está vinculada a ${requiredProvider}. Este atendimento com ${selectedProvider} será cobrado por fora.`;
  }

  if (
    params.reason === "OUTSIDE_CURRENT_PERIOD" ||
    params.reason === "SUBSCRIPTION_PERIOD_ENDED"
  ) {
    const periodEnd = formatDateOnly(params.currentPeriodEnd);
    const selectedDate = formatDateOnly(params.selectedDate);
    if (periodEnd && selectedDate) {
      return `Sua assinatura cobre atendimentos até ${periodEnd}. O horário escolhido é ${selectedDate}, então este agendamento não entra na assinatura.`;
    }
    if (periodEnd) {
      return `Sua assinatura cobre atendimentos até ${periodEnd}. Este agendamento não entra na assinatura porque está fora do período atual.`;
    }
  }

  return params.fallbackMessage;
}

/**
 * MBR-12: motivo curto por serviço, para a lista do modal de cobertura parcial.
 * A frase longa (`resolveCustomerCoveragePromptMessage`) fala do agendamento
 * inteiro; aqui cada linha diz só por que aquele serviço ficou fora.
 */
export function resolveServiceCoverageReasonLabel(reason?: string | null): string {
  switch (String(reason || "").toUpperCase()) {
    case "SERVICE_NOT_INCLUDED":
      return "Não faz parte do plano";
    case "SERVICE_LIMIT_EXCEEDED":
      return "Limite do período já usado";
    case "WEEKDAY_NOT_INCLUDED":
      return "Dia fora do plano";
    case "PROVIDER_NOT_INCLUDED":
      return "Profissional fora do plano";
    case "OUTSIDE_CURRENT_PERIOD":
    case "SUBSCRIPTION_PERIOD_ENDED":
      return "Fora do período da assinatura";
    default:
      return "Fora da assinatura";
  }
}
